<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshTable"
      @on-load="onLoad"
    >
      <template slot="roomName" slot-scope="scope">
        <wq-overHidden :content="scope.row.roomName">
          <span>{{ scope.row.roomName }}</span>
        </wq-overHidden>
      </template>
      <template slot-scope="scope" slot="buildingForm">
        <el-select
          v-model="form.building"
          placeholder="请选择楼栋/单元"
          clearable
          @change="getTreeNode(4, form.building)"
          :disabled="buildingDisabled"
        >
          <el-option
            v-for="item in buildingList"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="balance">
        <div>{{ tool.money_format_allowvoid(scope.row.balance) }}</div>
      </template>
      <!-- <template slot="balance" slot-scope="scope">
        {{tool.money_format_allowvoid({{scope.row.balance}})}}
      </template> -->
      <template slot-scope="scope" slot="roomIdForm">
        <el-select
          v-model="form.roomId"
          filterable
          @change="saveRoomId"
          placeholder="请选择房间"
          clearable
          :disabled="buildingDisabled"
        >
          <el-option
            v-for="item in roomList"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          @click="handleRegister"
          >快速登记
        </el-button>
        <el-button
          type="primary"
          size="small"
          >高级修改
        </el-button>
        <el-button
          type="primary"
          size="small"
          >车牌变更
        </el-button>
        <el-button
          type="primary"
          size="small"
          >主副车变更
        </el-button>
        <el-button
          type="danger"
          size="small"
          plain
          >注销
        </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-setting"
          @click="openCarChargeDialog(scope.row)"
        >
          充值
        </el-button>
      </template>
    </avue-crud>
    <el-dialog title="充值" :visible.sync="chargeShowDialogFlag" :modal-append-to-body="false">
      <div class="el-property-dialog-div">
        <avue-form
          ref="carChargeFormRef"
          v-model="carChargeForm"
          :option="carChargeOption"
          @close="quitCarChargeDialog"
          @submit="saveCarCharge"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCarChargeDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <!-- <hr-dialog
        width='80%'
        :visible.sync="dialogVisible"
        :title="title"
        :handleClose='handleClose'
    >
        <template slot="body">
          
        </template>
    </hr-dialog> -->
    <parkvihicle-register-form
      :dialogVisible.sync="showRegisterFormFlag"
        :handleClose='handleClose'
        :title="'快速登记'"
        :form="registerForm"
        :spaceId="query.parkingLotId"
    >
    </parkvihicle-register-form>
  </basic-container>
</template>

<script>
import {
  add,
  getList,
  remove,
  update,
  syncVehicles,
  saveCarCharge,
} from '@/api/v4ward/park/vehiclev3/parkvehicle';
import { getParkGroupList } from '@/api/v4ward/park/groupv2/parkgroup';
import { monthChargeRuleList } from '@/api/v4ward/carv2/carmonthchargerule';
import { driverSelections } from '@/api/v4ward/park/driverv2/parkdriver';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { mapGetters } from 'vuex';
import carChargeOption from './parkvehicle-carCharge';
import parkvihicleRegisterForm from '@/views/v4ward/park/vehiclev3/parkvehicle-register-form';
import { getDetailById as getCarParkspace } from '@/api/v4ward/carv2/carpark';
import { loadBuildingList, loadRoomList } from '@/api/chargev2/charge-pay';
import { getToken } from '@/util/auth';

export default {
  components: {
    parkvihicleRegisterForm,
  },
  data() {
    return {
      ruleDic: [],
      reWrite: false,
      spaceList: [],
      tempParkingLotId: '',
      firstDisplayFlag: false,
      buildingDisabled: true,
      buildingList: [],
      unitList: [],
      roomList: [],
      isaddCarMonthDialogFirstOpen: true,
      addCarMonthShowDialogFlag: false,
      showRegisterFormFlag:false,
      addCarMonthForm: {
        spaceId: '',
        payMoney: '',
      },
      regionFirstIdTemp: '',
      addFlag: false,

      buyStartTimeTemp: '',
      buyEndTimeTemp: '',

      //充值配置
      chargeShowDialogFlag: false,
      carChargeForm: {
        vehicleId: '',
        parkingLotId: '',
        parkingLotName: '',
        plateNumber: '',
        vehicleType: '',
        driverName: '',
        mobile: '',
        balance: '',
        tradeFee: '',
        payMethod: '',
        remark: '',
      },
      carChargeOption: carChargeOption,

      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      operateType: '',
      option: {
        height: 'auto',
        //calcHeight: 30,
        tip: true,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        addBtn: false,
        viewBtn: true,
        menuWidth: 300,
        add_carMonthBtn: true,
        selection: true,
        selectionClearBtn: true,
        dialogClickModal: false,
        labelWidth: 120,
        columnBtn: true,
        refreshBtn: true,
        stripe: true,
        column: [
          {
            // 用于搜索使用
            label: '车场名称',
            prop: 'parkingLotIdSearch',
            type: 'select',
            display: false,
            hide: true,
            showColumn: false,
            search: true,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
          },
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'select',
            editDisabled: true,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
            change: ({ value, column }) => {
              // 查询区域
              //this.loadRegion(value);
              // 加载收费规则
              this.loadRuleList(value);
              //加载车主
              this.loadDriverList(value);
              // 加载车辆分组
              // this.loadGroupList(value);
            },
          },
          {
            label: '车牌号',
            prop: 'plateNumber',
            editDisabled: true,
            width: 100,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入车牌号',
                trigger: 'blur',
              },
              {
                required: true,
                pattern: this.$validation.carPlate,
                message: '车牌号格式不对',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '车主姓名',
            prop: 'driverId',
            type: 'tree',
            editDisabled: true,
            hide: true,
            showColumn: false,
            editDisplay: false,
            viewDisplay: false,
            dicData: [],
            props: {
              label: 'label',
              value: 'value',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车主姓名',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆类型',
            prop: 'vehicleType',
            type: 'select',
            width: 80,
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=vehicle_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请选择车辆类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车牌颜色',
            prop: 'plateColor',
            type: 'select',
            hide: true,
            showColumn: false,
            editDisplay: false,
            dicUrl: 'api/blade-system/dict/dictionary?code=plate_color',
            props: { label: 'dictValue', value: 'dictValue' },
            rules: [
              {
                required: true,
                message: '请选择车牌颜色',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆品牌',
            prop: 'vehicleBrand',
            type: 'select',
            hide: true,
            showColumn: false,
            editDisplay: false,
            dicUrl: 'api/blade-system/dict/dictionary?code=vehicle_brand',
            props: { label: 'dictValue', value: 'dictValue' },
            rules: [
              {
                required: false,
                message: '请选择车辆品牌',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车身颜色',
            prop: 'vehicleColor',
            type: 'select',
            hide: true,
            showColumn: false,
            editDisplay: false,
            dicUrl: 'api/blade-system/dict/dictionary?code=vehicle_color',
            props: { label: 'dictValue', value: 'dictValue' },
            rules: [
              {
                required: false,
                message: '请选择车牌颜色',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车主姓名',
            prop: 'driverName',
            maxlength: 10,
            viewDisplay: true,
            addDisplay: false,
            editDisplay: true,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入车主姓名',
                trigger: 'change',
              },
              {
                min: 2,
                max: 10,
                message: '长度在2到10个字之间',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '手机号码',
            prop: 'mobile',
            addDisplay: false,
            rules: [
              {
                required: true,
                message: '请输入手机号码',
                trigger: 'change',
              },
              {
                required: true,
                pattern: this.$validation.phone,
                message: '请输入正确的手机号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆类别',
            prop: 'driverType',
            addDisplay: false,
            width: 80,
            type: 'select',
            rules: [
              {
                required: true,
                message: '请选择车辆类别',
                trigger: 'change',
              },
            ],
            dicData: [
              { label: '业主', value: 1 },
              { label: '非业主', value: 2 },
            ],
          },
          {
            label: '房产信息',
            prop: 'roomName',
            width: 200,
            slot: true,
            span: 24,
            maxlength: 50,
            showWordLimit: true,
            addDisplay: false,
          },
          {
            label: '备注信息',
            prop: 'remark',
            span: 24,
            type: 'textarea',
            minRows: 2,
            maxlength: 100,
            hide: true,
            showColumn: false,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: '余额',
            prop: 'balance',
            span: 24,
            slot: true,
            align: 'right',
            addDisplay: false,
            editDisabled: true,
          },
        ],
      },

      data: [],
    };
  },
  watch: {
    'form.driverType'() {
      this.changeSelectionStatus();
    },
    'form.parkingLotId'() {
      if (typeof this.form.parkingLotId !== 'undefined' && this.form.parkingLotId !== '') {
        //this.form.roomName = '';
        getCarParkspace({ id: this.form.parkingLotId }).then(({ data }) => {
          if (this.vdui.isNotEmpty(data.areaId)) {
            loadBuildingList({ propertyId: data.areaId }).then((res) => {
              this.buildingList = res.data;
            });
            // lazyBasePropertyTree(data.areaId).then((res) => {
            //   this.buildingList = res.data;
            // });
          }
        });
      }
    },
    'form.spaceId'() {
      this.form.ruleId = '';
      let spaceIdTem = this.form.spaceId;
      if (this.vdui.isNotEmpty(spaceIdTem)) {
        monthChargeRuleList(Object.assign({ spaceId: spaceIdTem })).then(({ data }) => {
          const column = this.findObject(this.option.column, 'ruleId');
          column.dicData = data;
        });
      }
    },
    'addCarMonthForm.cycleNum'() {
      this.initShoudMoney();
    },
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkvehicle_add, false),
        viewBtn: this.vaildData(this.permission.parkvehicle_view, false),
        delBtn: this.vaildData(this.permission.parkvehicle_delete, false),
        editBtn: this.vaildData(this.permission.parkvehicle_edit, false),
        syncBtn: this.vaildData(this.permission.parkvehicle_sync, false),
        charge: this.vaildData(this.permission.parkvehicle_charge, false),
        exportBtn: this.vaildData(this.permission.parkvehicle_export, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.option.height = this.bodyHeight - 380;
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
        spaceColumn.dicData = data.data;

        // 搜索栏使用
        var spaceSearChColumn = this.findObject(this.option.column, 'parkingLotIdSearch');
        spaceSearChColumn.dicData = data.data;

        spaceSearChColumn.searchValue = this.spaceList[0].id;
        // 默认查询第一个
        this.query.parkingLotId = this.spaceList[0].id;
        this.tempParkingLotId = this.spaceList[0].id;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
    this.option.height = this.bodyHeight - 380;
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document
          .querySelector(
            '#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)'
          )
          .addEventListener('click', () => {
            if (this.option.height == this.bodyHeight - 380) {
              this.option.height = this.bodyHeight - 280;
            } else {
              this.option.height = this.bodyHeight - 380;
            }
            this.$refs.crud.getTableHeight();
          });
      }, 1000);
    });
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$refs.crud.$refs.table.doLayout();
    });
  },
  methods: {
    
    handleClose(){
     this.showRegisterFormFlag = false
    
    },
    handleRegister(){
      this.showRegisterFormFlag = true;
    },
    exportVehicleForm() {
      this.$confirm("是否根据页面当前条件导出数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if (this.page.total <= 0) {
          this.$message.warning('未获取到车辆信息，请检查查询条件');
          return;
        }
        let parkingLotId = this.query.parkingLotId;
        let plateNumber = "";
        if(this.query.plateNumber){
          plateNumber = this.query.plateNumber;
        }
        let driverName = "";
        if(this.query.driverName){
          driverName = this.query.driverName;
        }
        let ids = this.ids;
        window.open(
          `/api/park/vehicle/export/v2?${
            this.website.tokenHeader
          }=${getToken()}&parkingLotId=${parkingLotId}&driverName=${driverName}&plateNumber=${plateNumber}&ids=${ids}`
        );
      });
    },
    changeSelectionStatus() {
      if (typeof this.form.driverType === 'undefined') {
        return;
      }
      //driverType = 1 ---业主，业主可以填房间信息
      this.buildingDisabled = this.form.driverType !== 1;

      let buildingColumn = this.findObject(this.option.column, 'building');
      let unitNameColumn = this.findObject(this.option.column, 'unitName');
      let roomIdColumn = this.findObject(this.option.column, 'roomId');
      if (this.form.driverType === 1) {
        //buildingColumn.editDisplay = true;
        buildingColumn.rules = [{ required: true, message: '请选择楼栋', trigger: 'change' }];
        unitNameColumn.rules = [{ required: true, message: '请选择单元', trigger: 'change' }];
        roomIdColumn.rules = [{ required: true, message: '请选择房间', trigger: 'change' }];
        //unitNameColumn.editDisplay = true;
        //roomIdColumn.editDisplay = true;
      } else {
        //buildingColumn.editDisplay = false;
        buildingColumn.rules = [];
        unitNameColumn.rules = [];
        roomIdColumn.rules = [];
        //unitNameColumn.editDisplay = false;
        //roomIdColumn.editDisplay = false;
      }
    },
    getTreeNode(type, id) {
      if (type == 4) {
        loadRoomList({ propertyId: id }).then(({ data }) => {
          console.log(data);
          this.form.roomId = '';
          this.roomList = data;
        });
      } else {
        loadRoomList({ propertyId: id }).then(({ data }) => {
          this.roomList = data;
        });
      }
      // getTreeChildrenPowerNode({
      //   object_type: type,
      //   id: id,
      // }).then((res) => {
      //   if (type == 1) {
      //   }else if (type == 4) {
      //     //单元下拉数据
      //     this.unitList = res.data;
      //     this.form.unitName = '';
      //     this.form.roomId = '';
      //     this.roomList = [];
      //   } else if (type == 6) {
      //     // this.propertyId_ = id;
      //     //房间下拉数据
      //     this.form.roomId = '';
      //     this.roomList = res.data;
      //   } else {
      //     this.form.building = '';
      //     this.form.unitName = '';
      //     this.form.roomId = '';
      //   }
      //   //this.$forceUpdate();
      // });
    },
    saveRoomId(e) {
      this.form.propertyId = e;
    },

    isEmpty(str) {
      return (!_.isNumber(str) && _.isEmpty(str)) || str === 'null' || str === 'undefined';
    },
    handleSync() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定下发所选车辆信息到对应车场终端?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return syncVehicles({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },

    // 加载车主主数据
    loadDriverList(parkId) {
      if (this.operateType === 'edit') {
        return;
      }
      const driverIdColumn = this.findObject(this.option.column, 'driverId');
      this.form.driverId = '';
      if (this.vdui.isNotEmpty(parkId)) {
        driverSelections({ id: parkId }).then((res) => {
          driverIdColumn.dicData = res.data;
        });
      } else {
        driverIdColumn.dicData = [];
      }
    },
    // 加载车辆分组
    loadGroupList(parkId) {
      const groupListColumn = this.findObject(this.option.column, 'groupList');
      this.form.groupList = '';
      if (this.vdui.isNotEmpty(parkId)) {
        getParkGroupList({ id: parkId }).then((res) => {
          groupListColumn.dicData = res.data;
        });
      } else {
        groupListColumn.dicData = [];
      }
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      if (row.balance > 0) {
        this.$message.warning('车辆【' + row.plateNumber + '】存在余额，不能删除！');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      //判断选中记录中余额是否为0
      this.selectionList.forEach((e) => {
        if (e) {
          if (e.balance > 0) {
            this.$message.warning('车辆【' + e.plateNumber + '】存在余额，不能删除！');
            return;
          }
        }
      });
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      this.operateType = type;
      if (['add'].includes(type)) {
        if (this.operateType === 'add') {
          //this.findObject(this.option.column, 'regionList').dicData = [];
          //this.findObject(this.option.column, 'setmealId').dicData = [];
          this.findObject(this.option.column, 'driverId').dicData = [];
          //this.findObject(this.option.column, 'groupList').dicData = [];
        }
      }
      if (['edit', 'view'].includes(type)) {
        this.form.building = this.form.buildingId;
        this.form.roomId = this.form.room;
        // this.getTreeNode(5,this.form.building)
      } else {
        setTimeout(() => {
          console.log(this.query.parkingLotId);
          this.form.parkingLotId = this.query.parkingLotId;
        }, 0);
      }
      done();
    },
    searchReset() {
      this.query = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshTable() {
      this.onLoad();
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时parkingLotId为空，则将parkingLotId置为当前的第一个车场
      if (this.query.parkingLotIdSearch == undefined || this.query.parkingLotIdSearch == '') {
        this.query.parkingLotId = this.tempParkingLotId;
        this.query.spaceId = this.tempParkingLotId;
      } else {
        this.query.parkingLotId = this.query.parkingLotIdSearch;
        this.query.spaceId = this.query.parkingLotIdSearch;
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.parkingLotIdSearch = this.spaceList[0].id;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }
      );
    },

    //充值
    openCarChargeDialog(row) {
      this.chargeShowDialogFlag = true;
      this.carChargeForm.tradeFee = row.tradeFee;
      this.carChargeForm.balance = row.balance;
      this.carChargeForm.driverName = row.driverName;
      this.carChargeForm.vehicleType = row.vehicleType;
      this.carChargeForm.parkingLotId = row.parkingLotId;
      this.carChargeForm.mobile = row.mobile;
      this.carChargeForm.parkingLotName = row.parkingLotName;
      this.carChargeForm.plateNumber = row.plateNumber;
      this.carChargeForm.vehicleId = row.id;
    },
    quitCarChargeDialog(form, done) {
      this.chargeShowDialogFlag = false;
      this.$refs.carChargeFormRef.resetForm();
    },
    saveCarCharge(form, done) {
      saveCarCharge(this.carChargeForm).then(
        () => {
          this.quitCarChargeDialog();
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
  },
};
</script>

<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
